import yup from "../../../../../utils/yup-extended";
import {ProfileSocialMediaOptions} from "../../../../../utils/profile";

export const profileSchema = yup.object().shape({
  displayName: yup.string().trim().required("Display name is required"),
  firstName: yup.string().trim().noSpaces().required("First name is required"),
  lastName: yup.string().trim().noSpaces().required("Last name is required"),
  shortBio: yup.string().trim().required("Short bio is required"),
  country: yup.string().trim().required("Please select a country"),
  username: yup
    .string()
    .trim()
    .noSpaces()
    .min(3, "Minimum of 3 characters")
    .lowercase("Only lowercase letters")
    .required("Username is required"),
  shortDescription: yup.string().trim().required("Short description is required"),
  socialLinks: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().trim().required("Name is required"),
        link: yup.string().trim().urlWithEmoji().required("Link is required"), // <- nice and tidy
      })
    )
    .notRequired()
    .test(
      "unique-platforms",
      "Platforms must be unique",
      (links: {name: string; link: string}[] | undefined) => {
        if (!links || links.length === 0) return true;
        const platforms = links.map((link) => link.name);
        return new Set(platforms).size === platforms.length;
      }
    ),
});

export type ProfileFormValuesYup = yup.InferType<typeof profileSchema>;
export type ProfileFormValues = {
  displayName: ProfileFormValuesYup["displayName"];
  firstName: ProfileFormValuesYup["firstName"];
  lastName: ProfileFormValuesYup["lastName"];
  shortBio: ProfileFormValuesYup["shortBio"];
  country: ProfileFormValuesYup["country"];
  username: ProfileFormValuesYup["username"];
  shortDescription: ProfileFormValuesYup["shortDescription"];
  emailAddress: string;
  socialLinks: {
    name: ProfileSocialMediaOptions;
    link: string;
  }[];
  how_did_you_find_us: string;
};
